import itContent from './services.it.json';
import enContent from './services.en.json';

const servicesContent = {
  it: itContent.items || [],
  en: enContent.items || []
};

export default servicesContent;
